import script from "./PropertyScoreCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyScoreCard.vue?vue&type=script&setup=true&lang=js"

import "./PropertyScoreCard.vue?vue&type=style&index=0&id=307f82b1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-307f82b1"]])

export default __exports__